import React from 'react'

import {
  DropdownButton,
  DropdownButtonEllipsis,
  DropdownWrapper,
  ImageElement,
} from '../DocumentItem/DocumentItem.styles'
import {
  Thumbnail,
  ThumbnailWrapper,
  StyledStatusIcon,
} from './ProjectTrashItem.styles'
import { LoadingPlaceholder } from '@sketch/components'
import { ReactComponent as ImagePlaceholder } from '@sketch/icons/document-64-svg'

import { useResponsiveDropdown } from 'components/ResponsiveDropdown'

type ThumbnailItem = { name: string; imageSource?: string }
export interface ProjectTrashItemProps {
  className?: string
  name: string
  deletedAt: string
  documentsNumber?: number
  thumbnails?: ThumbnailItem[]
  onClick?: React.MouseEventHandler<HTMLElement>
  renderDropdownItems?: () => React.ReactNode
}

const ActionPopoverWrapper: React.FC = ({ children }) => <div>{children}</div>

const ResponsiveDropdown: React.FC = ({ children }) => {
  const [content, buttonProps] = useResponsiveDropdown({
    dropdown: ActionPopoverWrapper,
    dropdownProps: {
      children,
    },
    placement: 'bottom-end',
    usePortal: true,
  })

  return (
    <DropdownWrapper onClick={event => event.stopPropagation()}>
      <DropdownButton {...buttonProps}>
        <DropdownButtonEllipsis aria-label="Deleted Project Settings" />
        <span className="sr-only">Deleted Project Settings</span>
      </DropdownButton>
      {content}
    </DropdownWrapper>
  )
}

export const renderDropdown = (children: React.ReactNode) => (
  <ResponsiveDropdown>{children}</ResponsiveDropdown>
)

export const getButtonProps = (
  handleOnClick: (event: React.MouseEvent<HTMLElement>) => void
) => ({
  role: 'button',
  tabIndex: 0,
  onClick: handleOnClick,
  onKeyPress: (event: React.KeyboardEvent<HTMLElement>) => {
    if (event.key === 'Enter') {
      /* Converge for the same type of event */
      handleOnClick((event as unknown) as React.MouseEvent<HTMLElement>)
    }
  },
})

export const renderPreview = (
  props: ProjectTrashItemProps,
  layout: 'grid' | 'list'
) => {
  const { name, thumbnails } = props

  if (!thumbnails || thumbnails?.length === 0) {
    return (
      <StyledStatusIcon as={ImagePlaceholder} aria-label="No Image available" />
    )
  } else {
    return (
      <ThumbnailWrapper aria-label={`Deleted project ${name}`}>
        {thumbnails?.map(({ name, imageSource }, index) => (
          <Thumbnail
            key={index}
            alt={name}
            customImageElement={ImageElement}
            src={imageSource}
            loadingPlaceholder={
              layout === 'grid' ? (
                <LoadingPlaceholder size="64px" />
              ) : (
                <LoadingPlaceholder size="16px" />
              )
            }
          />
        ))}
      </ThumbnailWrapper>
    )
  }
}
